Vue.filter('getAmazonLink', function (variationProperties) {
  let returnVal = '';

  for (const key in variationProperties) {
    for (const key2 in variationProperties[key].properties) {
      if (variationProperties[key].properties[key2].id === 808) {
        returnVal = variationProperties[key].properties[key2].values.value;
      }
    }
  }
  return returnVal;
});
